import React, {useEffect} from "react";
import {OfferForm, OfferRequestPartial} from "./createAndUpdate/OfferForm";
import {
    clearUpdateOfferState,
    fetchOfferToUpdate,
    initialOfferLoadingStatusSelector,
    updateOffer,
    updateOfferRequestSelector,
    updateOfferRequestStatusSelector,
    updateUpdateOfferRequest
} from "../offerUpdateSlice";
import {createOfferRequestPropertySelector} from "./selector/OfferStoreSelector";
import {useAppDispatch, useAppSelector} from "../../../../app/hooks";
import {Loader} from "../../../elements/loader/Loader";
import {
    fetchOfferList,
    fetchOfferMakeOptions,
    fetchOfferModelOptions, fetchOfferSourceNameOptions,
    offerTableRequestSelector
} from "../offerListSlice";
import {RequestStatus} from "../../../../api/apiConfiguration";
import {
    showErrorToastNotification,
    showSuccessToastNotification
} from "../../../elements/toastNotification/toastNotificationSlice";

interface UpdateOfferFormProps {
    publicId: string
    publicBotId?: string
    publicLocationId?: string
    handleClose: () => void
}

export const UpdateOfferForm: React.FC<UpdateOfferFormProps> = ({
                                                                    publicId,
                                                                    publicBotId,
                                                                    publicLocationId,
                                                                    handleClose
                                                                }) => {

    const dispatch = useAppDispatch();
    const offerTableRequest = useAppSelector(offerTableRequestSelector);
    const initialOfferLoadingStatus = useAppSelector(initialOfferLoadingStatusSelector);
    const updateOfferRequestStatus = useAppSelector(updateOfferRequestStatusSelector);

    useEffect(() => {
        if (initialOfferLoadingStatus === RequestStatus.NONE) {
            dispatch(fetchOfferToUpdate(publicId))
        }
        return () => {
            dispatch(clearUpdateOfferState());
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (updateOfferRequestStatus === RequestStatus.RESOLVED) {
            if (publicBotId) {
                dispatch(fetchOfferList({...offerTableRequest, publicBotId}))
            } else {
                dispatch(fetchOfferList({...offerTableRequest, publicLocationId}))
            }
            handleClose()
            dispatch(fetchOfferMakeOptions({publicBotId, publicLocationId}));
            dispatch(fetchOfferModelOptions({publicBotId, publicLocationId}));
            dispatch(fetchOfferSourceNameOptions({publicBotId, publicLocationId}));
            dispatch(showSuccessToastNotification({message: "Offer Updated Successfully"}))
        } else if (updateOfferRequestStatus === RequestStatus.REJECTED) {
            dispatch(showErrorToastNotification({message: "Failed to update offer"}))
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [updateOfferRequestStatus]);

    if (initialOfferLoadingStatus === RequestStatus.RESOLVED) {

        const updateRequest = (update: OfferRequestPartial) => {
            dispatch(updateUpdateOfferRequest(update))
        }

        const onSubmit = () => {
            dispatch(updateOffer())
        }

        const formTitle = publicBotId ? "Update offer in bot" : "Update offer in location"

        return <OfferForm
            formTitle={formTitle}
            onClose={handleClose}
            onSubmit={onSubmit}
            updateRequest={updateRequest}
            selectionProvider={createOfferRequestPropertySelector(updateOfferRequestSelector)}
        />
    } else {
        return <Loader/>
    }
}
